import React from 'react';

interface PagePuzzleIntroProps {
  onRequestClose?: () => void;
}

export const PagePuzzleIntro: React.FC<PagePuzzleIntroProps> = ({ onRequestClose }) => {
  return (
    <div style={{ padding: '8px 4px 24px', color: '#e2e8f0', maxWidth: 380, margin: '0 auto' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 24 }}>
        <Step icon="✨" text="Every day brings a new theme with a set of starting terms." />
        <Step icon="🔗" text="Tap two unlocked terms — or drag one onto a slot — to try combining them." />
        <Step icon="🆕" text="A successful combination unlocks a new term and shows you why it works." />
        <Step icon="🌟" text="Terms are grouped into constellations. Unlock every term in a constellation to complete it." />
        <Step icon="🏆" text="Complete all constellations to win!" />
      </div>

      <p style={{ fontSize: 13, color: '#6b7280', textAlign: 'center', marginBottom: 20 }}>
        Not every pairing works — experiment and think creatively!
      </p>

      <button
        onClick={onRequestClose}
        style={{
          width: '100%',
          padding: 14,
          borderRadius: 12,
          border: 'none',
          background: '#6366f1',
          color: '#fff',
          fontSize: 16,
          fontWeight: 700,
          cursor: 'pointer',
          fontFamily: 'cubano, sans-serif',
          letterSpacing: '0.03em',
        }}
      >
        Start Playing
      </button>
    </div>
  );
};

const Step: React.FC<{ icon: string; text: string }> = ({ icon, text }) => (
  <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
    <span style={{ fontSize: 22, flexShrink: 0 }}>{icon}</span>
    <span style={{ fontSize: 14, color: '#cbd5e1', lineHeight: 1.5 }}>{text}</span>
  </div>
);
